import angular from 'angular'
import component from './component'
import authorTypeFilter from './authorTypeFilter'

export default angular
  .module('ellipsis.authorSelection', [])
  .component('authorSelection', component)
  .filter('authorType', authorTypeFilter)
